var map = {
	"./android/DeviceSetup": 1735,
	"./androidtv/DeviceSetup": 1736,
	"./arris/DeviceSetup": 1737,
	"./hisense/DeviceSetup": 1738,
	"./lg/DeviceSetup": 1739,
	"./nagra/DeviceSetup": 1741,
	"./netrange/DeviceSetup": 1742,
	"./opera/DeviceSetup": 1743,
	"./polaroid/DeviceSetup": 1744,
	"./ps4/DeviceSetup": 1745,
	"./samsung/DeviceSetup": 1746,
	"./seirobotics/DeviceSetup": 1747,
	"./sony/DeviceSetup": 1748,
	"./stbcoship/DeviceSetup": 1749,
	"./stbcoship9108/DeviceSetup": 1750,
	"./stbhuawei/DeviceSetup": 1751,
	"./stbkaon/DeviceSetup": 1752,
	"./tizen/DeviceSetup": 1753,
	"./web0s/DeviceSetup": 1754,
	"./workstation/DeviceSetup": 1756,
	"./workstationChafari/DeviceSetup": 1757,
	"./zeasn/DeviceSetup": 1758,
	"./zte/DeviceSetup": 1759
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1734;


//////////////////
// WEBPACK FOOTER
// ./src/devices ^\.\/.*\/DeviceSetup$
// module id = 1734
// module chunks = 0